<template>
  <div class="dropdown-container" ref="dropdown">
    <!-- Dropdown Toggle -->
    <div class="dropdown-toggle" @click="toggleDropdown">
      <div class="dropdown-selected">
        <span class="text-xs p-3">{{ displayDate }}</span>
      </div>
      <span class="px-3">
        <IconArrow />
      </span>
    </div>

    <!-- Dropdown Menu -->
    <div v-if="isOpen" class="dropdown-options shadow-lg">
      <div class="dropdown-content">
        <label class="mb-2">From</label>
        <input type="date" class="form-control text-xs mb-3" v-model="localFromDate" @change="updateDate" />

        <label class="mb-2">To</label>
        <input type="date" class="form-control text-xs mb-3" v-model="localToDate" @change="updateDate" />

        <div class="d-flex justify-content-between mt-2">
          <button class="btn btn-small btn-theme" @click="resetDates">Reset</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconArrow from '../../../components/icons/IconArrow.vue'
export default {
  components: {
    IconArrow,
  },
  props: {
    fromDate: String,
    toDate: String,
  },
  data() {
    return {
      isOpen: false, // Controls dropdown visibility
      localFromDate: this.fromDate || "",
      localToDate: this.toDate || "",
    }
  },
  computed: {
    displayDate() {
      if (this.localFromDate && this.localToDate) {
        const yearFrom = this.localFromDate.slice(0, 4)
        const monthFrom = this.localFromDate.slice(5, 7)
        const dayFrom = this.localFromDate.slice(8, 10)

        const yearTo = this.localToDate.slice(0, 4)
        const monthTo = this.localToDate.slice(5, 7)
        const dayTo = this.localToDate.slice(8, 10)

        // YYYY/MM/DD - YYYY/MM/DD
        return `${yearFrom}/${monthFrom}/${dayFrom} - ${yearTo}/${monthTo}/${dayTo}`
      } else {
        return "Pilih periode"
      }
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside)
  },

  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },

    normalizeDate(date, setEndOfDay = false) {
      if (!date) return null
      const d = new Date(date)
      if (setEndOfDay) {
        d.setHours(23, 59, 59, 999) // Set to 23:59:59
      } else {
        d.setHours(0, 0, 0, 0) // Set to 00:00:00
      }
      return d.toISOString() // Keep it consistent across time zones
    },
    updateDate() {
      const normalizedFrom = this.normalizeDate(this.localFromDate, false)
      const normalizedTo = this.normalizeDate(this.localToDate, true)

      this.$emit("update:fromDate", normalizedFrom)
      this.$emit("update:toDate", normalizedTo)
      this.$emit("dateChanged", {
        from: normalizedFrom,
        to: normalizedTo,
      })
    },
    resetDates() {
      this.localFromDate = ""
      this.localToDate = ""
      this.updateDate()
    },

    handleClickOutside(event) {
      if (this.isOpen && this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false
      }
    },
  },
}
</script>

<style scoped>
.dropdown-container {
  position: relative;
  width: fit-content;
  font-family: Arial, sans-serif;
}

.dropdown-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.375rem;
  background-color: var(--grey-1-color);
  cursor: pointer;
}

.dropdown-selected {
  display: flex;
  align-items: center;
}

.dropdown-options {
  position: absolute;
  top: 105%;
  left: 0;
  /* width: 100%; */
  border-radius: 0 0 0.25em 0.25em;
  background-color: var(--grey-1-color);
  z-index: 1000;
}

.dropdown-content {
  padding: 10px;
  min-width: 220px;
}

.form-control {
  width: 100%;
  padding: 5px;
  font-size: 0.75rem;
}

.btn-theme {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 0.75rem;
}

.btn-theme:hover {
  background-color: var(--primary-dark-color);
}
</style>
